export default "__VITE_ASSET__B3paGFL7__"